import { EditorState } from '@adflow/types';

const DOCUMENT_FIELDS = [
  'elements',
  'name',
  'bgColour',
  'dataSources',
  'displayOptions',
  'brand',
  'brandKit',
  'brandKitId',
  'importSourceJSON',
  'importSourceType',
  'customFonts',
  'businessEntityId',
  'animation',
] as const;

type StoreSet = (
  partial:
    | EditorState
    | Partial<EditorState>
    | ((state: EditorState) => EditorState | Partial<EditorState>),
  replace?: boolean,
) => void;

export function partialTouchesDocument(partial: Partial<EditorState> | EditorState): boolean {
  return DOCUMENT_FIELDS.some((field) => Object.prototype.hasOwnProperty.call(partial, field));
}

function revisionExplicitlyChanged(
  partial: Partial<EditorState> | EditorState,
  previousRevision: number,
): boolean {
  return (
    Object.prototype.hasOwnProperty.call(partial, 'workingRevision') &&
    partial.workingRevision !== previousRevision
  );
}

export function withDocumentRevision(set: StoreSet, get: () => EditorState): StoreSet {
  return (partial, replace) => {
    if (typeof partial === 'function') {
      set((state) => {
        const next = partial(state);
        const previousRevision = state.workingRevision ?? 0;
        if (!partialTouchesDocument(next) || revisionExplicitlyChanged(next, previousRevision)) {
          return next;
        }
        return { ...next, workingRevision: previousRevision + 1 };
      }, replace);
      return;
    }

    const previousRevision = get().workingRevision ?? 0;
    if (!partialTouchesDocument(partial) || revisionExplicitlyChanged(partial, previousRevision)) {
      set(partial, replace);
      return;
    }

    set({ ...partial, workingRevision: previousRevision + 1 }, replace);
  };
}
